import { OUR_PEOPLE } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import OurPeopleCard from '@stories/Components/Cards/OurPeopleCard/OurPeopleCard';
import FilteredListing from '@stories/Components/Filtering/FilteredListing/FilteredListing';
import { Helmet, HelmetData } from 'react-helmet-async';
import queryString from 'query-string';
import React from 'react';
import { BooleanParam, JsonParam, NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import S from './OurPeopleListing.styles';
import { ceil } from 'lodash';
const OurPeopleListing = ({ pageContext, initialData, expertiseFilter, sortByOptions, officeFilter, errorText, }) => {
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        favourites: BooleanParam,
        filter: withDefault(JsonParam, {}),
        pageIndex: NumberParam,
        sortBy: StringParam,
    });
    const helmetData = new HelmetData({});
    const [filterTemp, setFilterTemp] = React.useState(queryParams.filter);
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    // Get sort by or default.
    const sortByValue = queryParams.sortBy ?? sortByOptions[0].value;
    const pageSize = 9;
    // Construct API url.
    const parameters = queryString.stringify({
        docId: pageContext?.documentId,
        filter: JSON.stringify(queryParams.filter),
        pageIndex: pageIndex,
        pageSize: pageSize,
        sortBy: sortByValue,
    });
    const apiUrl = `${OUR_PEOPLE}?${parameters}`;
    // Fetch data.
    const { data, error, complete } = useApi(apiUrl);
    // Get items from response or initial items.
    const items = data?.items ?? initialData.items;
    const totalItems = data?.totalItems ?? initialData.totalItems;
    const pageAmount = ceil(totalItems / pageSize);
    function getAbsUrl(relativeUrl) {
        if (typeof window !== "undefined") {
            return window.location.origin + window.location.pathname + relativeUrl;
        }
        return undefined;
    }
    function getNextPageUrl(query) {
        const nextIndex = (parseInt(query.pageIndex, 10) || 1) + 1;
        if (nextIndex > pageAmount) {
            return undefined;
        }
        const search = queryString.stringify({
            pageIndex: nextIndex,
        });
        return getAbsUrl(`?${search}`);
    }
    function getPrevPageUrl(query) {
        const prevIndex = (parseInt(query.pageIndex, 10) || 1) - 1;
        if (prevIndex < 1) {
            return undefined;
        }
        const search = queryString.stringify({
            pageIndex: prevIndex,
        });
        return getAbsUrl(`?${search}`);
    }
    const prevUrl = getPrevPageUrl(queryParams);
    const nextUrl = getNextPageUrl(queryParams);
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, { helmetData: helmetData },
            prevUrl ? React.createElement("link", { rel: "prev", href: prevUrl }) : null,
            nextUrl ? React.createElement("link", { rel: "next", href: nextUrl }) : null),
        React.createElement(FilteredListing, { errorText: errorText, error: error, filtersProps: {
                filters: [expertiseFilter, officeFilter],
                filterValue: filterTemp,
                sortByOptions: sortByOptions,
                sortByValue: sortByValue,
                onSortChange: (val) => setQueryParams({ sortBy: val, pageIndex: 1 }),
                onSubmitFilter: () => {
                    setQueryParams({ filter: filterTemp, pageIndex: 1 }, 'pushIn');
                },
                onFilterChange: (name, value, replace, update) => {
                    if (replace) {
                        setFilterTemp({ ...filterTemp, [name]: [value] });
                        if (value === '') {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                        }
                        return;
                    }
                    const passValues = filterTemp[name];
                    const values = new Set(passValues ?? []);
                    if (values.has(value)) {
                        values.delete(value);
                    }
                    else {
                        values.add(value);
                    }
                    // Remove key altogether if no values.
                    if (values.size === 0) {
                        if (update) {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                            setQueryParams({ filter, pageIndex: 1 }, 'pushIn');
                        }
                        else {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                        }
                        return;
                    }
                    // Otherwise updated filter with new values.
                    setFilterTemp({ ...filterTemp, [name]: [...values] });
                    // Used to remove filter values from the query string if they are already present and need removing
                    if (update) {
                        setQueryParams({ filter: { ...queryParams.filter, [name]: [...values], pageIndex: 1 } }, 'pushIn');
                    }
                }
            }, items: items, complete: complete, pageSize: pageSize, pageIndex: pageIndex, renderItems: (items) => (React.createElement(S.ItemList, null, items.map((item, i) => (React.createElement(S.Item, { key: i },
                React.createElement(OurPeopleCard, { ...item })))))), totalItems: totalItems, onPageChange: (pageIndex) => {
                setQueryParams({ pageIndex });
            } })));
};
export default withQueryParams(OurPeopleListing);
